import { GENDERLIST_MENTOR, GENDERS, ROUTE_PATH } from "common/constants/sm-constants";
import {
  FormMetaModel,
  SmMetaInputModel,
  SmMetaSelectModel,
} from "common/models/utility-models/meta-model";

export class MentorMappingFilterMetaModel extends FormMetaModel {
  constructor() {
    super("", ROUTE_PATH.applicantGrid, "", 3);
  }

  override initProperties(): any {
    const formInfo = super.initProperties();

    const batch = new SmMetaSelectModel(
      "batch",
      "batch",
      "select",
      false,
      "col-12 col-md-4",
      1,
      1,
      "",
      "select",
      "Select Batch",
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      "batch_number",
      "batch_number"
    );

    const branch = new SmMetaSelectModel(
      "branch",
      "branch",
      "select",
      false,
      "col-12 col-md-4",
      1,
      1,
      "",
      "select",
      "Select Branch",
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      "department_name",
      "department_name"
    );

    const mentor_name = new SmMetaSelectModel(
      "mentor_name",
      "mentor_name",
      "select",
      false,
      "col-12 col-md-4",
      1,
      1,
      "",
      "select",
      "Select Mentor Name",
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      "mentorName",
      "mentorName"
    );

    const search = new SmMetaInputModel(
      'search',
      'search',
      'input',
      false,
      'col-12 col-md-4',
      1,
      3,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    return {
      formInfo,
      search,
      mentor_name,
      batch,
      branch
    };
  }
}
